import React, { Component } from "react";
import News_BannerTitle from "../../../layouts/news/News_BannerTitle";
import {
  Header,
  TopBar,
  BottomBar,
} from "../../../layouts/_admin/general/index";
import { firestore } from "src/helpers/Firebase";
import Image from "../../../layouts/inputs/Image";
import RichText from "../../../layouts/inputs/RichText";
import { DateToTimestamp, TimestampToDate } from "src/helpers/functions";

class Admin_EditNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      categories: [],
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Novosti",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/news-list",
          titlelink: "Novosti",
          border: "|",
          name: "Uređivanje novosti",
          heading: "Uređivanje novosti",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    const { location } = this.props;

    const params = new URLSearchParams(location.search);

    const ID = params.get("ID");

    firestore
      .collection("Web/Corporate/DataBase/News/Categories")
      .get()
      .then((querySnapshot) => {
        const categories = [];

        querySnapshot.forEach((doc) => {
          categories.push({ ...doc.data(), ID: doc.id });
        });

        if (ID) {
          firestore
            .doc(`Web/Corporate/DataBase/News/DataBase/${ID}`)
            .get()
            .then((snapshot) => {
              const data = snapshot.data();

              this.setState({
                data: {
                  ...data,
                  ID: snapshot.id,
                  releaseDate: TimestampToDate(data.releaseDate, {}, true),
                },
                categories,
                loading: false,
              });
            });
        } else {
          var now = new Date();
          now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

          now.setMilliseconds(null);
          now.setSeconds(null);

          this.setState({
            loading: false,
            data: {
              title: "",
              categories: [],
              releaseDate: now.toISOString().slice(0, -1),
              author: "",
              shortContent: "",
              content: "",
            },
            categories,
          });
        }
      });
  }

  onSubmit() {
    this.setState({ loading: true });
    const { data } = this.state;
    const { history } = this.props;

    if (data.ID) {
      firestore
        .doc(`Web/Corporate/DataBase/News/DataBase/${data.ID}`)
        .set({
          ...data,
          releaseDate: DateToTimestamp(new Date(data.releaseDate)),
        })
        .then(() => {
          this.setState({ loading: false });
        });
    } else {
      firestore
        .collection("Web/Corporate/DataBase/News/DataBase")
        .add({
          ...data,
          releaseDate: DateToTimestamp(new Date(data.releaseDate)),
        })
        .then((doc) => {
          history.push(`/admin/news-edit?ID=${doc.id}`);
          this.loadData();
        });
    }
  }

  onDelete() {
    const { data } = this.state;
    const { history } = this.props;

    firestore
      .doc(`Web/Corporate/DataBase/News/DataBase/${data.ID}`)
      .delete()
      .then(() => {
        history.push("/admin/news-list");
      });
  }

  render() {
    const { history } = this.props;
    const { loading, data, categories } = this.state;

    return (
      <div className="header-fixed sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <News_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />

                {loading ? (
                  <div className="loading" />
                ) : (
                  <>
                    <div className="col-12 p-2">
                      <label>Title</label>
                      <input
                        className="col-12"
                        type="text"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, title: e.target.value },
                          })
                        }
                        value={data.title}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Header Image</label>
                      <Image
                        value={data.headerImage}
                        updateValue={(val) =>
                          this.setState({ data: { ...data, headerImage: val } })
                        }
                        refURL={`Web/News`}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Category</label>
                      <div check="true" style={{ padding: "0" }}>
                        {categories.map((category) => (
                          <div
                            key={`checkbox_option_wrapper_${category.title}`}
                          >
                            <input
                              className="ml-2"
                              type="checkbox"
                              key={`checkbox_option_${category.title}`}
                              id={`checkbox_option_${category.title}`}
                              checked={data.categories.includes(category.title)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  const newCategories = [...data.categories];
                                  newCategories.push(category.title);
                                  this.setState({
                                    data: {
                                      ...data,
                                      categories: newCategories,
                                    },
                                  });
                                } else {
                                  let newCategories = [...data.categories];
                                  newCategories = newCategories.filter(
                                    (x) => x !== category.title
                                  );
                                  this.setState({
                                    data: {
                                      ...data,
                                      categories: newCategories,
                                    },
                                  });
                                }
                              }}
                              inline="true"
                            />
                            <label
                              key={`checkbox_option_label_${category.title}`}
                              className="ml-2"
                            >
                              {category.title}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="col-12 p-2">
                      <label>Short content</label>
                      <textarea
                        className="col-12"
                        type="text"
                        value={data.shortContent}
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, shortContent: e.target.value },
                          })
                        }
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Content</label>
                      <RichText
                        value={data.content}
                        updateValue={(val) =>
                          this.setState({
                            data: { ...data, content: val },
                          })
                        }
                        refURL={`Web/News`}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Author</label>
                      <input
                        className="col-12"
                        type="text"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, author: e.target.value },
                          })
                        }
                        value={data.author}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <label>Release date</label>
                      <input
                        className="col-12"
                        type="datetime-local"
                        onChange={(e) =>
                          this.setState({
                            data: { ...data, releaseDate: e.target.value },
                          })
                        }
                        value={data.releaseDate}
                      />
                    </div>

                    <div className="col-12 p-2">
                      <input
                        type="button"
                        onClick={() => {
                          history.push("/admin/news-list");
                        }}
                        value="Cancel"
                      />

                      <input
                        className="float-right"
                        type="button"
                        onClick={() => this.onSubmit()}
                        value="Submit"
                      />

                      {data.ID && (
                        <input
                          className="float-right"
                          type="button"
                          onClick={() => this.onDelete()}
                          value="Delete"
                        />
                      )}
                    </div>
                  </>
                )}

                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={80}
                  data-mobile={60}
                  data-smobile={60}
                />
              </div>
            </div>
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Admin_EditNews;
